import { render, staticRenderFns } from "./Tagged.vue?vue&type=template&id=571f3494"
import script from "./Tagged.vue?vue&type=script&lang=js"
export * from "./Tagged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports